<template>
  <div class="collapsible-item" :class="!isActiveCopy ? 'item-collapse' : ''">
    <div class="item-heading" @click="click">
      <slot name="heading"></slot>
    </div>
    <div class="item-body" v-show="isActiveCopy">
      <slot name="body"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "collapsibleItem",
  props: {
    isActive: {
      type: Boolean
    },
    type: {
      type: String
    }
  },
  data() {
    return {
      isActiveCopy: this.isActive
    }
  },
  methods: {
    click() {
      this.isActiveCopy = !this.isActiveCopy
      this.$emit("collapsibleItemClick", this)
    }
  },
  mounted() {}
}
</script>
<style>
.collapsible-item {
  display: flex;
  flex-flow: column;
  width: 100%;
  padding-left: 4px;
  box-sizing: border-box;
}
.item-body .collapsible-item {
  padding-left: 0px;
}
.collapsible-item .item-heading {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  align-items: center;
  font-size: 14px;
  color: var(--collapsibleItemHeadingColor);
  padding: 8px 0px 8px 14px;
  position: relative;
  /*border-top:#484848 solid 1px;*/
  /*border-bottom: #282828 solid 1px;*/
  cursor: default;
}

.collapsible-item .item-heading:hover {
  /*background: rgba(255, 255, 255, 0.05);*/
  cursor: pointer;
}

.collapsible-item .item-heading span {
  margin-right: 5px;
}

.collapsible-item .item-heading small {
  white-space: nowrap;
  color: #aaa;
  font-size: 11px;
}

.collapsible-item .item-heading::after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  /* top: calc(50% - 4px); */
  top: 50%;
  transform: translateY(-20%);
  left: 0;
  border-width: 4px;
  border-style: solid;
  border-color: var(--collapsibleItemHeadingAfterColor);
}

.collapsible-item .item-body {
  flex: 1;
  padding-left: 15px;
}
.collapsible-item .item-body .item-body {
  padding: 0 0 0 15px;
}
.collapsible-item.item-collapse .item-heading::after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  /* top: calc(50% - 2px); */
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  border-width: 4px;
  border-style: solid;
  border-color: var(--collapsibleItemHeadingCollapseAfterColor);
}

.collapsible-item.item-collapse .item-body {
  display: none;
}
.padding8 {
  padding: 8px 0;
}
.collapsible-item .item-body {
  padding-bottom: 4px;
}
.collapsible-item .item-body .content-item {
  line-height: 18px;
  margin-top: 12px;
}
.collapsible-item .item-body .content-item:first-child {
  margin-top: 0px;
}
.collapsible-item .item-body .content-item  .el-checkbox__label {
  line-height: 18px;
}
</style>
